import { defineMessages } from 'react-intl';

export const errorMessageChkSeq = defineMessages({
  printerNo: {
    defaultMessage:
      'Printer details failed to load. Please retry. If issue persists, please contact CDK Support.',
    description:
      'Error message to display when the default printer fails to load the info.'
  },
  checkNo: {
    defaultMessage: 'Check no. is required',
    description: 'Error message to display when Check No is not entered'
  },
  alreadyUsedCheckNo: {
    defaultMessage:
      'This check number has already been used. Please verify and try again.',
    description:
      'Error message to display when the check number has been used already'
  },
  noPrinterSelection: {
    defaultMessage: 'Printer selection is required to print checks.',
    description: 'Error message to display when the printer selection is empty'
  },
  noEformsSetup: {
    defaultMessage:
      'This cash in bank account has not been configured to use eForms. Please contact CDK Support.',
    description: 'Error message to display when there is no Eforms Setup'
  },
  noChecksSelected: {
    defaultMessage:
      'No checks selected. To continue, return to the Print Checks tab and select the checks you would like to print.',
    description: 'Error message to display when the printer selection is empty'
  }
});

export const labels = defineMessages({
  defaultPrinterLabel: {
    defaultMessage: 'Printer',
    description: 'Default printer number label'
  },
  overflowPrinterLabel: {
    defaultMessage: 'Overflow Printer',
    description: 'Overflow printer number label'
  },
  nextAvailableCheckLabel: {
    defaultMessage: 'Next Available Check No.',
    description: 'Next available check no. label'
  },
  useDifferentCheckNo: {
    defaultMessage: 'Use a different check number',
    description: 'Use a different check number label'
  },
  checkNo: {
    defaultMessage: 'Check No.',
    description: 'Input field Check No as label'
  },
  theseChecksOnly: {
    defaultMessage: 'Use for these checks only',
    description: 'Radio option label for use for these checks only'
  },
  futureChecks: {
    defaultMessage:
      'Set as starting number for future checks from this printer tray',
    description: 'Radio option label for future checks'
  }
});

export const messages = defineMessages({
  printerVal: {
    defaultMessage: 'Select',
    description: 'printer dropdown default value'
  },
  checkTrayVal: {
    defaultMessage: 'Select',
    description: 'CheckTray dropdown default value'
  },
  overFlowTrayVal: {
    defaultMessage: 'Select',
    description: 'OverFlowTray dropdown default value'
  },
  archiveOnly: {
    defaultMessage: 'Archive only',
    description: 'Archive only dropdown value'
  },
  printingInProgress: {
    defaultMessage:
      'Printing may be in-progress. Please verify the printer is available before proceeding.',
    description: 'Default message to display as a warning'
  }
});
